import { CssBaseline, Grid, Paper } from '@mui/material';
import { FC } from 'react';

import AuthSideCover from '../AuthSideCover';

const AuthLayout: FC = ({ children }) => (
  <Grid container component="main" sx={{ height: '100vh' }}>
    <CssBaseline />
    <Grid
      justifyContent="center"
      alignItems="center"
      container
      item
      xs={12}
      sm={8}
      md={5}
      component={Paper}
      elevation={6}
      square
    >
      {children}
    </Grid>
    <AuthSideCover />
  </Grid>
);

export default AuthLayout;
